export default __webpack_public_path__ + "static/media/objects-manual.7bf0a89a.svg";